import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Folder browsing now lives inside the Files page
 * (/buildings/:id/documents, Folders tab) — the standalone
 * /buildings/:id/folders page and its /buildings/:id/projects predecessor
 * are both gone. Old deep links — bookmarks, emails, share flows — land here
 * and are forwarded. The query string is preserved: `?project=` feeds the
 * global scope, and the Files page still migrates the legacy
 * `?projectId=&folderId=` pair (emitted by breadcrumb tooltips) onto it.
 */
export function LegacyFoldersRedirect() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  return <Navigate to={`/buildings/${id}/documents${location.search}`} replace />;
}
